import './searchable-drop-down.scss'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { defineComponent } from 'vue'
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'

export const SEARCHABLE_DROPDOWN_ITEM_SELECTED = 'searchable-drop-down-item-selected'
export const SEARCHABLE_DROPDOWN_SELECTED_ITEMS_CHANGED =
    'searchable-drop-down-selected-items-changed'

export interface SearchableDropDownItem {
    id: string
    text: string
}

export interface SearchableDropDownSearchResult {
    items: SearchableDropDownItem[],
    nbPages: number,
}

export default defineComponent({
    mixins: [reactiveVueMixin],
    components: {},
    props: ['searchFunction', 'multipleSelection', 'pageSize'],
    template: require('./searchable-drop-down.html'),
    data() {
        return {
            items: [] as SearchableDropDownItem[],
            selectedItem: { id: '', text: '' } as SearchableDropDownItem,
            selectedItems: [] as SearchableDropDownItem[],
            searchText: '',
            open: false,

            currentPageNumber: 1,
            nbPages: NaN,

            searchIcon: faSearch,
            removeIcon: faTimes,
        }
    },
    mounted() {
        this.search()
    },
    watch: {
        searchText() {
            this.currentPageNumber = 1
            this.search()
        },
    },
    methods: {
        search() {
            this.searchFunction(
                this.searchText,
                this.currentPageNumber-1,
                this.pageSize,
                this.multipleSelection ? this.selectedItems : undefined,
            ).subscribe(({ items, nbPages }: SearchableDropDownSearchResult) => {
                this.items = items
                this.nbPages = nbPages
            })
        },
        onItemSelected(item: SearchableDropDownItem) {
            if (this.multipleSelection) {
                this.selectedItems.push(item)
                this.$emit(SEARCHABLE_DROPDOWN_SELECTED_ITEMS_CHANGED, this.selectedItems)
                this.currentPageNumber = 1
                this.search()
            } else {
                this.selectedItem = item
                this.$emit(SEARCHABLE_DROPDOWN_ITEM_SELECTED, item)
            }
            this.open = !this.open
            this.searchText = ''
        },
        onRemoveItem(index: number) {
            this.selectedItems.splice(index, 1)
            this.search()
        },
        incrementPageNumber() {
            if(this.currentPageNumber < this.nbPages) {
                this.currentPageNumber++
                this.search()
            }
        },
        decrementPageNumber() {
            if(this.currentPageNumber > 1) {
                this.currentPageNumber--
                this.search()
            }
        },
        goToPage(page: number) {
            if(1 <= page && page <= this.nbPages && page !== this.currentPageNumber ) {
                this.currentPageNumber = page
                this.search()
            }
        },
    },
})
